import {renderMergeTagsComponent} from '@Global/email-maker';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';
import {getMergeTagsFromOptionId, hydrateMergeTagsReduxFromComponent} from '@/email-maker/grapesjs-email-editor-plugin/src/commands/editor';
import {replaceMergeTag} from '@Libraries/merge-tags-library';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  const MERGE_TAGS_ELEMENT_ID = 'merge-tags-element';

  styleManager.addType(window.PMW.emails.styles.ID_MERGE_TAGS, {
    create() {
      const mergeTagsContainer = document.createElement('div');
      mergeTagsContainer.id = MERGE_TAGS_ELEMENT_ID;
      const ccid = editor.getSelected()?.ccid;

      if (!ccid) {
        return;
      }

      renderMergeTagsComponent(mergeTagsContainer, {
        ccid,
        onTagAdded: (ccid, value) => {
          editor.getSelected()?.append(getMergeTagsFromOptionId(value));
          editor.runCommand(window.PMW.emails.commands.UPDATE_MERGE_TAGS);
        },
        onTagRemoved: (ccid, value) => {
          const selectedComponent = editor.getSelected();

          if (!selectedComponent) {
            return;
          }

          const element = selectedComponent.getEl();

          if (!element) {
            return;
          }

          const newContent = replaceMergeTag(value, element.innerText, '');
          selectedComponent.components(newContent);
        },
        onDefaultValueUpdate: (ccid, mergeTagKey, defaultValue) => {
          const wrapper = editor.getWrapper();

          if (!wrapper) {
            return;
          }

          wrapper.find(`[data-gjs-type="${window.PMW.emails.components.text.PMW_TEXT}"]`).forEach((textComponent) => {
            const selectedComponent = textComponent;
            const element = selectedComponent.getEl();
            const currText = element ? element.innerText : '';
            const newContent = replaceMergeTag(mergeTagKey, currText, getMergeTagsFromOptionId(mergeTagKey, defaultValue));
            selectedComponent.components(newContent);
          });
        },
      });

      return mergeTagsContainer;
    },
  });
};
